import { get } from '../../../utils/api';
import isomorphicCookies from '../../../utils/isomorphicCookies';

export default {
  getBanners: () =>
    get({
      url: 'slider/list',
      // на время аб теста
      data: { is_short: isomorphicCookies().get('ab_test_version') === '1' ? 1 : 0 },
    }),
};
